import React from "react";
import { Scissors, Shirt, Factory, Layers, ArrowUpRight } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { Reveal, Overline } from "@/components/Reveal";

const ICONS = [Scissors, Shirt, Factory, Layers];

const Services = () => {
  const { t } = useSite();
  const s = t.services;

  return (
    <section id="services" data-testid="services-section" className="relative bg-card py-24 lg:py-32">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="max-w-2xl">
          <Reveal>
            <Overline>{s.overline}</Overline>
            <h2 className="mt-6 font-heading text-4xl font-light leading-tight tracking-tight sm:text-5xl">
              {s.title}
            </h2>
            <p className="mt-6 font-body text-base font-light leading-relaxed text-muted-foreground sm:text-lg">
              {s.subtitle}
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-px border border-border bg-border md:grid-cols-2">
          {s.items.map((item, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={i} delay={i * 0.08}>
                <div
                  data-testid={`service-card-${i}`}
                  className="group relative h-full bg-card p-10 transition-colors duration-500 hover:bg-background"
                >
                  <div className="flex items-start justify-between">
                    <span className="flex h-14 w-14 items-center justify-center border border-border text-gold transition-colors duration-500 group-hover:border-gold">
                      <Icon size={24} strokeWidth={1.4} />
                    </span>
                    <span className="font-mono text-xs text-muted-foreground">
                      0{i + 1}
                    </span>
                  </div>
                  <h3 className="mt-8 flex items-center gap-2 font-heading text-2xl font-normal">
                    {item.title}
                    <ArrowUpRight
                      size={18}
                      className="text-gold opacity-0 transition-all duration-300 group-hover:translate-x-0.5 group-hover:opacity-100"
                    />
                  </h3>
                  <p className="mt-4 font-body text-sm font-light leading-relaxed text-muted-foreground">
                    {item.desc}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
